import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idPartner: number;
  password: string;
};

export const updatePartnerPassword = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('updatePartnerPassword'), {
    method: 'PUT',
    body,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
